var React = require('react');

function IconArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#141313;}")),React.createElement("title",{"key":1},"Ativo 2"),React.createElement("g",{"id":"Camada_2","data-name":"Camada 2","key":2},React.createElement("g",{"id":"Camada_1-2","data-name":"Camada 1"},React.createElement("path",{"className":"cls-1","d":"M20.89,9.66a1.38,1.38,0,0,0,0-1.08v0a1.75,1.75,0,0,0-.32-.48L12.93.43a1.5,1.5,0,0,0-2.1,0,1.48,1.48,0,0,0,0,2.1l5.1,5.1H1.48a1.49,1.49,0,0,0,0,3H15.93l-5.1,5.1a1.48,1.48,0,1,0,2.1,2.1l7.64-7.63a1.66,1.66,0,0,0,.32-.49Z"})))]);
}

IconArrowRight.defaultProps = {"viewBox":"0 0 21 18.24"};

module.exports = IconArrowRight;

IconArrowRight.default = IconArrowRight;
